import momentJalaali from "moment-jalali";
import React, { useRef, useState } from 'react';
import { Alert, Button, Col, Form, FormGroup, Modal, Row, Table } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import { getRelatedStaffsToAgent, setReferServicePopup, updateManageSendingStaff } from "../../store/api/Services";
import { setErrorDialog } from '../../../store/api/CommonFunctions';
import Loader from 'react-loader-spinner';
import { ReplyFill, Search, ExclamationTriangle, X, DashCircle } from 'react-bootstrap-icons';
import DatePicker from "react-datepicker2";
const ModalReferToOther = (props) => {
    const showStaffInfo = useRef(false);
    const sendSMS = useRef(true);
    const referStaff = useRef({});
    const searchData = useRef({});
    const [isPending, setIsPending] = useState(false);
    const sendDate = useRef(momentJalaali().local("en").format("YYYY-MM-DD HH:mm"));
    const [error, setError] = useState(null);
    const { serviceInfo } = props;
    const openReferServicePopup = useSelector(state => state.popup.openReferServicePopup);
    const relatedStaffs = useSelector(state => state.service.relatedStaffs);
    const dispatch = useDispatch();
    const { serviceID, serviceType, show } = openReferServicePopup;
    const referService = () => {
        if(isPending)
        {
            return;
        }
        if (!referStaff.current.ID) {
            setErrorDialog(dispatch, "هیچ ردیفی انتخاب نشده است", "ارجاع به تکنسین");
            return;
        }

        const onRefer = (res) => {
            setIsPending(false);
            if (serviceInfo && res === "success") {
                serviceInfo.StaffID = referStaff.current.ID;
                serviceInfo.StaffName = referStaff.current.LastName;
                serviceInfo.StaffServiceCostFixAmountShare = (serviceInfo.ServiceType?.toLowerCase() === "install" ? referStaff.current.StaffInstallCostPercentShare : referStaff.current.StaffRepairCostFixAmountShare) ?? 0;
                serviceInfo.StaffServiceCostPercentShare = (serviceInfo.ServiceType?.toLowerCase() === "install" ? referStaff.current.StaffInstallCostPercentShare : referStaff.current.StaffRepairCostPercentShare) ?? 0;
                serviceInfo.StaffUsedPartsCostPercentShare = referStaff.current.StaffUsedPartsCostPercentShare ?? 0;
                serviceInfo.StaffUsedPartsCostFixAmountShare = referStaff.current.StaffUsedPartsCostFixAmountShare ?? 0;
                serviceInfo.StaffExtraUsedPartsCostPercentShare = referStaff.current.StaffExtraUsedPartsCostPercentShare ?? 0;
                serviceInfo.StaffExtraUsedPartsCostFixAmountShare = referStaff.current.StaffExtraUsedPartsCostFixAmountShare ?? 0;
                serviceInfo.StaffExtraServicesCostPercentShare = referStaff.current.StaffExtraServicesCostPercentShare ?? 0;
                serviceInfo.StaffExtraServicesCostFixAmountShare = referStaff.current.StaffExtraServicesCostFixAmountShare ?? 0;
                serviceInfo.StaffTransportationPercentShare = referStaff.current.StaffTransportationPercentShare ?? 0;
                serviceInfo.StaffTransportationFixAmountShare = referStaff.current.StaffTransportationFixAmountShare ?? 0;
                serviceInfo.StaffMainCoAmountPaymentPercentShare = referStaff.current.StaffMainCoAmountPaymentPercentShare ?? 0;
                serviceInfo.StaffMainCoAmountPaymentFixAmountShare = referStaff.current.StaffMainCoAmountPaymentFixAmountShare;
                serviceInfo.Status = "اعزام شد";
                serviceInfo.StatusName = "sent";
            }
            dispatch(setReferServicePopup({ show: false }));
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, "ارجاع به تکنسین");
            }
            else {
                setErrorDialog(dispatch, "عملیات با موفقیت انجام شد", "ارجاع به تکنسین");
            }
            window.scrollTo(0, 0);
        }
        const data = {
            ServiceType: serviceType,
            ServiceID: serviceID,
            StaffID: referStaff.current.ID,
            ShowStaffInfoToCustomer: showStaffInfo.current,
            SendDate: sendDate.current,
            SendSMSToStaff: sendSMS.current
        }
        setIsPending(true);
        updateManageSendingStaff(data, onRefer);
    }
    const search = (e) => {
        if (e?.key) {
            if (e.key !== "Enter") {
                return;
            }
        }
        setError(null);
        dispatch(getRelatedStaffsToAgent(searchData.current, setError));
    }
    function close() {
        setError(null);
        dispatch(setReferServicePopup({ show: false }));
    }
    return (
        <Modal show={show === true} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className='headerStyle'><span><ReplyFill size={18} />&nbsp; ارجاع سرویس</span></Modal.Header>
            <Modal.Body className="bodyStyle" style={{ paddingTop: "0" }}>
                {error &&
                    <Alert variant='danger'>
                        <ExclamationTriangle size={18} />&nbsp;
                        {error}
                    </Alert>}
                <Row className="mt-2" style={{margin:0}}>
                    <Col md={4} style={{padding:2}}>
                        <input className="search-input" placeholder='نام تکنسین' onKeyDown={search}
                            onChange={e => searchData.current.Name = e.target.value} />
                        <Button className="btn-input-tiny" style={{ top: 6,left:5 }} onClick={search}><Search size={18} /></Button>
                    </Col>
                    <Col md={4}  style={{padding:2}}>
                        <input className="search-input" placeholder='کد تکنسین' onKeyDown={search}
                            onChange={e => searchData.current.Code = e.target.value} />
                        <Button className="btn-input-tiny" style={{ top: 6,left:5 }} onClick={search}><Search size={18} /></Button>
                    </Col>
                    <Col md={4}  style={{padding:2}}>
                        <input className="search-input" placeholder='کد دوم تکنسین' onKeyDown={search}
                            onChange={e => searchData.current.Code2 = e.target.value} />
                        <Button className="btn-input-tiny" style={{ top: 6,left:5 }} onClick={search}><Search size={18} /></Button>
                    </Col>                    
                </Row>

                <Table className='fixedTable mt-1' responsive>
                    <thead>
                        <tr>
                            <th style={{ width: "10%" }}>&nbsp;</th>
                            <th style={{ width: "90%" }}>&nbsp;</th>
                        </tr>
                    </thead>

                    <tbody>
                        {relatedStaffs === "PENDING" &&
                            <tr>
                                <td colSpan={2} style={{ width: "100%", textAlign: "center" }}>
                                    <Loader type="BallTriangle" color="#bb1370" height={30} width={30} />
                                </td>
                            </tr>
                        }
                        {relatedStaffs && Array.isArray(relatedStaffs) &&
                            relatedStaffs.map((item, i) =>
                                <tr key={i} className="resultTableRow">
                                    <td style={{ width: "10%" }}>
                                        <input type='radio' name='checkedStaff' className='form-check-input' style={{ cursor: "pointer" }} onChange={e => { if (e.target.checked) referStaff.current = item; }} />
                                    </td>
                                    <td style={{ width: "90%" }}>{item.Code + "-" + item.LastName}</td>
                                </tr>
                            )
                        }
                    </tbody>
                </Table>
                <Row className="rowBorder">
                    <FormGroup style={{ maxWidth: "max-content" }}>
                        <label>تاریخ ارجاع/اعزام: </label>
                        <DatePicker isGregorian={false} timePicker={true} className="form-control" value={momentJalaali()} onChange={value => sendDate.current = value.local("en").format("YYYY-MM-DD HH:mm")} inputJalaaliFormat="jYYYY/jMM/jDD HH:mm" />
                    </FormGroup>
                    <FormGroup style={{ maxWidth: "max-content" }}>
                        <div className="rowBorder" style={{ padding: "8px" }}>
                            <input type='checkbox' className='form-check-input' defaultChecked={false} onChange={e => showStaffInfo.current = e.target.checked} />
                            &nbsp;
                            <span style={{ fontSize: "12px", color: "blue" }}>نمایش اطلاعات تماس به مشتری</span>&nbsp;
                            <div style={{ display: "inline-block" }}>
                                <input type='checkbox' className='form-check-input' defaultChecked={true} onChange={e => sendSMS.current = e.target.checked} />
                                &nbsp;
                                <span style={{ fontSize: "12px", color: "blue" }}>ارسال پیامک به تکنسین</span>
                            </div>
                        </div>
                    </FormGroup>
                </Row>
                <div className='mt-2'>
                    <Button variant='success' className="group-Btn" style={{ fontSize: "12px" }} onClick={referService} disabled={isPending}>
                        {isPending ? <Loader type="TailSpin" color="white" width={16} height={16} style={{display:"inline-block"}}/>:
                        <ReplyFill size={15} />} &nbsp;ارجاع به تکنسین
                        </Button>
                    <Button variant='danger' className="group-Btn" style={{ fontSize: "12px" }} onClick={close}><DashCircle size={15} />&nbsp;انصراف</Button>
                </div>
            </Modal.Body>
        </Modal>
    )
}
export default ModalReferToOther;